export const previewImages = {
  schedule: require("../assets/images/previews/schedule-preview.png"),
  scheduleCropped: require("../assets/images/previews/schedule-view-cropped-preview-3.png"),
  reglamentPreview: require("../assets/images/previews/reglament-preview.png"),
  settingsPreview: require("../assets/images/previews/settings-preview.png"),
  editorPreview: require("../assets/images/previews/editor-preview.png"),
}

export const previewImagesFull = {
  schedule: require("../assets/images/previews/previews-full/schedule-view-highlight.png"),
  reglamentPreview: require("../assets/images/previews/previews-full/reglament.png"),
  editorPreview: require("../assets/images/previews/previews-full/editor-view-preview.png"),
  settingsPreview: require("../assets/images/previews/previews-full/settings.png"),
}

export const images = {
  // uad_logo_text: require("../assets/images/uad_logo_text.svg"),
  uad_logo_text_not_vector: require("../assets/images/uad_logo_text_not_vector.png"),
  uad_logo_text_not_vector_hires: require("../assets/images/uad_logo_text_not_vector_hires.png"),
}

export const teamMemberImages = {
  senchyk_andrii: require("../assets/images/team/senchyk_andrii.png"),
  zakharova_zarina: require("../assets/images/team/zakharova_zarina.png"),
  shepita_julia: require("../assets/images/team/shepita_julia.png"),
  ivanov_mykhailo: require("../assets/images/team/ivanov_mykhailo.png"),
}

export const editorImages = {
  lightbulb: require("../assets/images/editor/lightbulb-nontrasparent-fixed.png"),
}

export const drawerMenuImages = {
  uad_logo_white_outline: require("../assets/images/uad-logo-white-outline.png"),
}

export const imageIcons = {
  museum: require("../assets/image_icons/museum.png"),
  tiktok: require("../assets/image_icons/tiktok.png"),
  warning_triangle: require("../assets/image_icons/warning-triangle.png"),
}
